// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".message-pop::before {\n  content: \"\";\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 4px;\n  height: 100%;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  background: #1890ff;\n}\n.message-pop p {\n  margin: 0;\n}\n.message-pop .variable-message-class {\n  pointer-events: none;\n}", ""]);
// Exports
module.exports = exports;
